import styled from 'styled-components';

export const IframeWrapper = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const IframeOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 15px;
  right: 0;
  bottom: 0;
  z-index: 1;
  cursor: default;
`;

export const IframeContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 16px;
  gap: 24px;
  border-radius: 12px;
  background-color: #F0F0F0;
  width: 50%;
  height: 80vh;
  animation: slideIn 0.3s ease-out;

  @media (max-width: 480px) {
    width: 95%;
    padding: 12px;
    gap: 16px;
  }

  /* Large phones (481px - 640px) */
  @media (min-width: 481px) and (max-width: 640px) {
    width: 90%;
  }

  /* Tablets (641px - 768px) */
  @media (min-width: 641px) and (max-width: 768px) {
    width: 80%;
  }

  /* Small laptops (769px - 1024px) */
  @media (min-width: 769px) and (max-width: 1024px) {
    width: 65%;
  }

  /* Desktops (1025px+) */
  @media (min-width: 1025px) {
    width: 50%;
  }

  @keyframes slideIn {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1;
  width: 100%;
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1;
  width: 100%;
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1;
  width: 100%;
  overflow: hidden;
`;

export const TitlesBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 0;
`;

export const TitleText = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: bold;
  color: #333;
  text-align: center;
`;

export const VersionText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-align: center;
`;

export const VersionNumber = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

export const ContentBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px;
  gap: 8px;
  background-color: #FFFFFF;
  border-radius: 12px;
  flex: 1;
  width: 100%;
  min-height: 300px;
  overflow: hidden;
`;

export const StyledIframe = styled.iframe`
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 12px;
  min-height: 300px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  padding: 8px 0;
`;

export const CheckboxTouchable = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const CheckboxTextWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  text-align: right;
  flex-wrap: wrap;
`;

export const CheckboxText = styled.span`
  font-size: 16px;
  font-weight: 400;
  text-align: 'right'};
  color: #5C7179;
  flex-shrink: 1;
  flex-grow: 1;
`;

export const SubmitButton = styled.button<{ $isEnabled: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  width: 100%;
  height: 40px;
  border: 1px solid #C1C5C1;
  border-radius: 5px;
  background-color: ${({ $isEnabled }) => $isEnabled ? '#FCCB00' : 'white'};
  cursor: ${({ $isEnabled }) => $isEnabled ? 'pointer' : 'not-allowed'};
  font-size: 16px;
  font-weight: 400;
  color: black;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  z-index: 999;
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #40A8E2;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;